export const LANGUAGE_STORAGE_KEY = 'i18nextLng'

export function resolveInitialLanguage(stored: string | null | undefined): 'en' | 'id' {
  const value = (stored ?? '').trim()
  if (!value) return 'id'
  const lower = value.toLowerCase()
  if (lower.startsWith('en')) return 'en'
  if (lower.startsWith('id')) return 'id'
  return 'id'
}
